import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import BestSellingProducts from "./BestSellingProducts";
import RecentActivity from "./RecentActivity";
import RecentOrders from "./RecentOrders";
import Revenue from "./Revenue";
import SalesByLocations from "./SalesByLocations";
import Section from "./Section";
import StoreVisits from "./StoreVisits";
import TopSellers from "./TopSellers";
import axios from "axios";


const DashboardEcommerce = () => {
  document.title = "Dashboard | BuyPass";

  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  useEffect(() => {
    // const myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");
    // myHeaders.append("Cookie", "refresh_token=eyJhbGciOiJIUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI0ZjNkMjU4ZS0wNDQ3LTRjNDgtYTYzZS0yODA2Yzk1N2EyNDMifQ.eyJleHAiOjE3MzEzNTgwMjIsImlhdCI6MTczMTM1NjIyMiwianRpIjoiMWVmZGU0YTctMjQ1Yy00MDg3LWE3MjgtM2I4ZGI2MzZjNDBlIiwiaXNzIjoiaHR0cHM6Ly9hdXRoYnV5cGFzcy5uZWtzb2Z0LmNvbS9yZWFsbXMvdmVuZG9yLXJlYWxtIiwiYXVkIjoiaHR0cHM6Ly9hdXRoYnV5cGFzcy5uZWtzb2Z0LmNvbS9yZWFsbXMvdmVuZG9yLXJlYWxtIiwic3ViIjoiN2FjNzJhZTQtZGYxNC00NzkzLTg1MmQtMzRhOGUwODc4ZWQ1IiwidHlwIjoiUmVmcmVzaCIsImF6cCI6InZlbmRvci1yZWFsbSIsInNlc3Npb25fc3RhdGUiOiIzZWUxZjlhNy05YjQwLTRmMmYtYWEzNC0wNmFhOGE1ZDQzMjciLCJzY29wZSI6Im9wZW5pZCBlbWFpbCBwcm9maWxlIiwic2lkIjoiM2VlMWY5YTctOWI0MC00ZjJmLWFhMzQtMDZhYThhNWQ0MzI3In0.LfPzIDAjx4PL2nfpDOyHVP1_By2O02sqfb3EubWTZ-Q; session_state=3ee1f9a7-9b40-4f2f-aa34-06aa8a5d4327");
    
    // const raw = JSON.stringify({
    //   "userName": "03012162866",
    //   "password": "123456"
    // });
    
    // const requestOptions:any = {
    //   method: "POST",
    //   headers: myHeaders, 
    //   body: raw,
    //   redirect: "follow"
    // };
    
    // fetch("https://sellerbuypass.neksoft.com/api/v1/auth/login", requestOptions)
    //   .then((response) => response.text())
    //   .then((result) => console.log(result))
    //   .catch((error) => console.error(error));




    // axios.get(`/category?id=6732399ea221932dd1d83885`).then((res)=> {
    //   console.log(res);
    // })
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section rightClickBtn={toggleRightColumn} />
                <Row>
                  <Widget />
                </Row>
                <Row>
                  <Col xl={8}>
                    <Revenue />
                  </Col>
                  <SalesByLocations />
                </Row>
                <Row>
                  <BestSellingProducts />
                  <TopSellers />
                </Row>
                <Row>
                  <StoreVisits />
                  <RecentOrders />
                </Row>
              </div>
            </Col>
            {/* <RecentActivity rightColumn={rightColumn} hideRightColumn={toggleRightColumn} /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
